<template>
  <div class="container">

    <div class="row">
      <div class="col-12 text-left small-section">
        1. 분류: {{requestTypeString(item.requestType)}}
        <br>

        <span style="color:#FF5733;">운송기간은 픽업을 기준으로 14일 정도 소요됩니다.</span>
      </div>
      <div class="col-12 text-left small-section">
        2. 크기 & 무게
      </div>
    </div>
    <div class="row">
      <div class="col no-padding-bottom">세로</div>
      <div class="col no-padding-bottom">가로</div>
      <div class="col no-padding-bottom">높이</div>
      <div class="col no-padding-bottom">무게</div>
      <div class="col no-padding-bottom"> </div>

    </div>
    <template v-for="(box, bi) in item.boxList">
      <div class="row text-right" style="padding-bottom: 10px;">
        <div class="col no-padding">
          <select class="form-control" v-model="box.x" @change="onSizeEntered">
            <option v-for="(n, i) in 100" :value="n">{{n}}cm</option>
          </select>
        </div>
        <div class="col no-padding">
          <select class="form-control" v-model="box.y" @change="onSizeEntered">
            <option v-for="(n, i) in 100" :value="n">{{n}}cm</option>
          </select>
        </div>
        <div class="col no-padding">
          <select class="form-control" v-model="box.z" @change="onSizeEntered">
            <option v-for="(n, i) in 100" :value="n">{{n}}cm</option>
          </select>
        </div>
        <div class="col no-padding">
          <select class="form-control" v-model="box.aw" @change="onSizeEntered">
            <option v-for="(n, i) in 100" :value="n">{{n}}</option>
          </select>
        </div>
        <div class="col no-padding text-center" style="line-height: 38px;">
          <span v-if="bi > 0" v-on:click="removeBox(bi)"><i class="fas fa-trash"></i></span><span v-else> </span>
        </div>
      </div>
    </template>
    <div class="row">
      <div class="col-12 text-left" style="padding-left:0;">
        <span class="border-btn" v-on:click="addBox"><i class="fas fa-plus"></i> 박스 추가</span>
      </div>
    </div>
<!--    <div class="row">-->
<!--      <div class="col-3">-->
<!--        가로(cm)-->
<!--        <select class="form-control" v-model="item.volumeX" @change="onSizeEntered">-->
<!--          <option v-for="(n, i) in 100" :value="n">{{n}}</option>-->
<!--        </select>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        세로(cm)-->
<!--        <select class="form-control" v-model="item.volumeY" @change="onSizeEntered">-->
<!--          <option v-for="(n, i) in 100" :value="n">{{n}}</option>-->
<!--        </select>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        높이(cm)-->
<!--        <select class="form-control" v-model="item.volumeZ" @change="onSizeEntered">-->
<!--          <option v-for="(n, i) in 100" :value="n">{{n}}</option>-->
<!--        </select>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        무게(kg)-->
<!--        <select class="form-control" v-model="item.measuredWeight" @change="onSizeEntered">-->
<!--          <option v-for="(n, i) in 100" :value="n">{{n}}</option>-->
<!--        </select>-->
<!--      </div>-->
<!--    </div>-->
    <div class="row">
      <table class="table text-left price-container">
        <tr class="">
          <td class="">
            부피무게
          </td>
          <td class="">
            {{(this.item.volumeWeight/100).toFixed(2)}}
          </td>
        </tr>
        <tr class="">
          <td class="">
            예상가격
          </td>
          <td class="">
            {{(this.item.estimatedPrice/100).toFixed(2)}}
          </td>
        </tr>
        <tr class="">
          <td class="">
            픽업비:
          </td>
          <td class="">
            £{{(item.estimatedPickupPrice/100).toFixed(2)}}
          </td>
        </tr>
        <tr class="">
          <td class="">
            총예상:
          </td>
          <td class="">
            £{{(item.estimatedTotalPrice/100).toFixed(2)}}
          </td>
        </tr>
      </table>
    </div>

    <div class="row">
      <div class="col-12 text-left">
        통관종류: {{customTypeString(item.customType)}}
      </div>
      <div class="col-12 text-left">
        거래구분: {{tradeTypeString(item.tradeType)}}
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-left small-section">
        3. 송하인 정보
      </div>
    </div>

    <div class="row text-left">

      <div class="col-12 ">
        픽업일 (신청일 기준 2일 후부터 가능 하며 매주 토,일,월 요일은 제외 입니다.)
        <input class="form-control" type="date" v-model="item.pickUpDate" @change="onPickUpDateSelected"/>
      </div>
      <div class="col-12 ">
        배송일
        <input class="form-control" type="date" v-model="item.dispatchDate" @change="onDispatchDateSelected"/>
      </div>

      <div class="col-12">
        Shipper<input class="form-control" type="text" v-model="item.sender"/>
      </div>
      <div class="col-12">
        전화번호
        <input class="form-control" type="text" v-model="item.senderContact"/>
      </div>
      <div class="col-12">
        Email<input class="form-control" type="text" v-model="item.senderEmail"/>
      </div>
      <div class="col-12">
        우편번호
        <input class="form-control" type="text" v-model="item.senderPostCode"/>
      </div>
      <div class="col-12">
        주소
        <input class="form-control" type="text" v-model="item.senderAddress1"/>
        <input class="form-control" type="text" v-model="item.senderAddress2"/>
      </div>
    </div>



    <div class="row">
      <div class="col-12 text-left small-section">
        4. 수하인 정보
      </div>
    </div>


    <div class="row text-left">
      <div class="col-12">
        화주종류
        <select class="form-control" v-model="item.receiverType">
          <option value="1">개인</option>
          <option value="2">회사</option>
        </select>
      </div>
      <div class="col-12">
        이름<input class="form-control" type="text" v-model="item.receiver"/>
      </div>
      <div class="col-12">
        통관부호<input class="form-control" type="text" v-model="item.customNumber"/>
      </div>
      <div class="col-12">
        전화번호<input class="form-control" type="text" v-model="item.receiverContact"/>
      </div>
      <div class="col-12">
        Email<input class="form-control" type="text" v-model="item.email"/>
      </div>
      <div class="col-12">
        <button class="btn btn-primary" v-on:click="findAddress"><i class="fas fa-search"></i> 주소검색</button>
      </div>
      <div class="col-12">
        우편번호<input class="form-control" type="text" v-model="item.postCode"/>
      </div>
      <div class="col-12">
        주소<input class="form-control" type="text" v-model="item.address1"/>
        <input class="form-control" type="text" v-model="item.address2"/>
      </div>
    </div>

    <template v-if="item.requestType === 'ecommerce'">
      <div class="row">
        <div class="col-12 text-left small-section">
          5. 물픔목록 Total Value: {{(item.value/100).toFixed(2)}}
        </div>
      </div>

      <div class="row text-left" v-for="(p, index) in itemList">
        <div class="col-12">
          품명 #{{index+1}}<input class="form-control" type="text" v-model="p.name"/>
        </div>
        <div class="col-12">
          브랜드<input class="form-control" type="text" v-model="p.brand"/>
        </div>
        <div class="col-12">
          URL<input class="form-control" type="text" v-model="p.url"/>
        </div>
        <div class="col-12">
          Country of Origin<input class="form-control" type="text" v-model="p.originCountry"/>
        </div>
        <div class="col-4">
          Value ($)<input class="form-control text-right" type="number" v-model="p.value" @change="onSubItemValueChanged(index)"/>
        </div>
        <div class="col-4">
          Quantity<input class="form-control text-center" type="number" v-model="p.amount" @change="onSubItemValueChanged(index)"/>
        </div>
        <div class="col-4">
          Total Value<input class="form-control text-right" type="number" :value="(p.amount * p.value).toFixed(2)" disabled/>
        </div>

        <div class="col-12 text-right">
          <span><i class="fas fa-trash"></i> 제거</span>
        </div>
        <hr class="col-12">
      </div>
      <div class="row">
        <div class="col-12 text-left">
          <span v-on:click="addItem"><i class="fas fa-plus"></i> 물품추가</span>
        </div>
      </div>
    </template>
    <div class="row">
      <div class="col-12 text-right">
        <button class="btn btn-primary" v-on:click="submit">신청</button>
      </div>
    </div>
    <div id="finder-container" class="fullscreen-container">
      <div id="postcodeFinderLayer" class="center-container">
<!--        <img src="//t1.daumcdn.net/postcode/resource/images/close.png" id="btnCloseLayer"-->
<!--             style="cursor:pointer;position:absolute;right:-3px;top:-10px;z-index:1" v-on:click="closeAddressFinder()"-->
<!--             alt="닫기 버튼"/>-->
        <div class="container">
          <div class="row fixed-bottom">
            <div class="col-12">
              <button class="form-control btn btn-secondary" v-on:click="closeAddressFinder">Close</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
    import {submitItemRequest, getNewSubItem, getRequestTypeString, getCustomTypeString, getTradeTypeString, getReceiverTypeString} from "../api/item";
    import EventBus from "../api/event-bus";
    import { getDateString, getDayOfWeek } from "../api/utils";
    import {getMetaByType} from "../api/meta";

    export default {
        name: "ExpressForm",
      props: {
        item: {
          type:Object,
          default: function(){return {}}
        }
      },
      data() {
          return {
            showAddressFinder: false,
            itemList:[],
            expressBasicPrice:false,
            expressAddPrice: false,
          }
      },
      created() {
        this.getExpMetaList();
      },
      mounted() {
        this.onSizeEntered();
      },
      methods: {
        requestTypeString:getRequestTypeString,
        customTypeString:getCustomTypeString,
        tradeTypeString:getTradeTypeString,
        receiverTypeString:getReceiverTypeString,
        onPickUpDateSelected: function() {
          if(this.item.dispatchDate === '0000-00-00' ||  this.item.pickUpDate === '0000-00-00') {
            return false;
          }
          let minDay = getDateString(2);
          console.log("min day " + minDay);
          if(this.item.pickUpDate < minDay) {
            this.item.pickUpDate = minDay;
            window.alert("최소 2일 후에 픽업 가능합니다.")
            return false;
          }
          let dayOfWeek = getDayOfWeek(this.item.pickUpDate);
          if(dayOfWeek == 0 || dayOfWeek == 1 || dayOfWeek == 6) {
            window.alert("토, 일, 월요일은 픽업하지 않습니다. 다른 요일을 선택해주세요");
            return false;
          }



          return true;

        },
        onDispatchDateSelected: function() {
          if(this.item.dispatchDate === '0000-00-00' ||  this.item.pickUpDate === '0000-00-00') {
            return false;
          }
          if(this.item.dispatchDate <= this.item.pickUpDate) {
            window.alert("배송일은 픽업일후에 가능합니다.");
            return false;
          }
          return true;
        },

        getExpMetaList: function() {
          let self = this;
          getMetaByType('exp_base_price')
            .then(function(data) {
              if(data.success == true) {
                self.$data.expressBasicPrice = data.item;
                self.onSizeEntered();
              }
            })
            .catch(function(err) {

            })
          getMetaByType('exp_add_price')
            .then(function(data) {
              if(data.success == true) {
                self.$data.expressAddPrice = data.item;
                self.onSizeEntered();
              }
            })
            .catch(function(err) {

            })
        },
        findAddress: function () {
          this.$data.showAddressFinder = true;
          var self = this;
          new daum.Postcode({
            oncomplete: function (data) {
              // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

              // 각 주소의 노출 규칙에 따라 주소를 조합한다.
              // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
              console.log(data);
              var addr = ''; // 주소 변수
              var extraAddr = ''; // 참고항목 변수

              //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
              if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                addr = data.roadAddress;
              } else { // 사용자가 지번 주소를 선택했을 경우(J)
                addr = data.jibunAddress;
              }

              // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
              if (data.userSelectedType === 'R') {
                // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
                  extraAddr += data.bname;
                }
                // 건물명이 있고, 공동주택일 경우 추가한다.
                if (data.buildingName !== '') {
                  extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
                }
                // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                if (extraAddr !== '') {
                  extraAddr = ' (' + extraAddr + ')';
                }
                // 조합된 참고항목을 해당 필드에 넣는다.
                //document.getElementById("sample2_extraAddress").value = extraAddr;

              } else {
                //document.getElementById("sample2_extraAddress").value = '';
              }

              // 우편번호와 주소 정보를 해당 필드에 넣는다.
              self.item.postCode = data.zonecode;
              self.item.address1 = addr;
              if (extraAddr !== '') {
                self.item.address2 += extraAddr;
              }
              //self.$data.basketPageDeliveryInfoEdit = true;
              //document.getElementById('sample2_postcode').value = data.zonecode;
              //document.getElementById("sample2_address").value = addr;
              // 커서를 상세주소 필드로 이동한다.
              //document.getElementById("sample2_detailAddress").focus();

              // iframe을 넣은 element를 안보이게 한다.
              // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
              self.$data.showAddressFinder = false;
              $("#finder-container").css('display', 'none');
              $("#postcodeFinderLayer").css('display', 'none');

            },
            width: '100%',
            height: '100%',
            maxSuggestItems: 5
          }).embed(document.getElementById('postcodeFinderLayer'));

          // iframe을 넣은 element를 보이게 한다.
          $("#finder-container").css('display', 'block');
          $("#postcodeFinderLayer").css('display', 'block');
        },
        closeAddressFinder: function () {
          this.$data.showAddressFinder = false;
          $("#finder-container").css('display', 'none');
          $("#postcodeFinderLayer").css('display', 'none');
        },
        submit: function() {

          //verify

          if(this.item.pickUpDate == "" || this.item.pickUpDate === "0000-00-00") {
            window.alert("픽업날짜를 선택해주세요");
            return;
          }
          if(this.item.dispatchDate == "" || this.item.dispatchDate === "0000-00-00") {
            window.alert("배송일을 선택해주세요");
            return;
          }
          if(this.onDispatchDateSelected() == false || this.onPickUpDateSelected() == false) {
            return;
          }


          if(this.item.sender.length == 0) {
            window.alert("Please enter sender's name");
            return;
          }
          if(this.item.senderPostCode.length < 5) {
            window.alert("Please enter sender's post code");
            return;
          }
          if(this.item.senderAddress1.length < 5) {
            window.alert("Please enter sender's address");
            return;
          }
          if(this.item.senderEmail.length < 5) {
            window.alert("Please enter sender's email");
            return;
          }

          if(this.item.receiver.length < 2) {
            window.alert("Please enter recipient's name");
            return;
          }
          if(this.item.receiverContact.length < 5) {
            window.alert("Please enter recipient's contact number");
            return;
          }
          if(this.item.postCode.length < 5) {
            window.alert("Please enter recipient's post code");
            return;
          }
          if(this.item.address1.length < 5) {
            window.alert("Please enter recipient's address");
            return;
          }

          if(this.item.email.length < 5) {
            window.alert("Please enter recipient's email address");
            return;
          }

          if(this.item.requestType === 'ecommerce') {
            if(this.item.customNumber.length < 5) {
              window.alert("Please enter recipient's custom ID");
              return;
            }
            if (this.$data.itemList.length == 0) {
              window.alert("물품을 추가해주세요");
              return;
            }

            for (let i = 0; i < this.$data.itemList.length; i++) {
              if (this.$data.itemList[i].name.length == 0) {
                window.alert("물품 " + (i + 1) + "번 이름을 입력해주세요");
                return;
              }
              if (this.$data.itemList[i].brand.length == 0) {
                window.alert("물품 " + (i + 1) + "번 브랜드명을 입력해주세요");
                return;
              }
              if (this.$data.itemList[i].url.length == 0) {
                window.alert("물품 " + (i + 1) + "번 URL을 입력해주세요");
                return;
              }
              if (this.$data.itemList[i].value <= 0) {
                window.alert("물품 " + (i + 1) + "번 value를 입력해주세요");
                return;
              }
              if (this.$data.itemList[i].amount <= 0) {
                window.alert("물품 " + (i + 1) + "번 개수를 입력해주세요");
                return;
              }
            }
            this.item.itemList = JSON.stringify(this.$data.itemList);
          }
          this.item.boxes = JSON.stringify(this.item.boxList);
          this.item.ct = this.item.boxList.length;


          if(this.item.requestType === 'ecommerce') {
            this.item.tradeType = 'A';
          } else {
            this.item.tradeType = 'C';
          }
          submitItemRequest(this.item)
          .then(function(data) {
            console.log(data);
            if(data.success == true) {
              EventBus.$emit('onSubmitted', data.item);

            } else {
              window.alert("요청이 이루어지지 않았습니다. " + data.message);
            }
          })
          .catch(function(err) {
            let msg = "Error " + err;
            if(err.response != undefined) {
              msg += " " + err.response;
            }
            window.alert(msg);

          })
        },
        onSizeEntered: function() {
          this.item.volumeWeight = 0;
          this.item.measuredWeight = 0;

          for(let i = 0 ; i < this.item.boxList.length ; i++) {
            this.item.volumeWeight += Number((this.item.boxList[i].x * this.item.boxList[i].y * this.item.boxList[i].z / 6000) *1000);
            this.item.measuredWeight += this.item.boxList[i].aw;
          }
          //this.$data.volume.cw = parseFloat(this.$data.volume.vw) > parseFloat(this.$data.volume.aw) ? parseFloat(this.$data.volume.vw) : parseFloat(this.$data.volume.aw);


          if(this.item.volumeWeight > this.item.measuredWeight*1000) {
            this.item.weight = this.item.volumeWeight;
          } else {
            this.item.weight = Number(this.item.measuredWeight*1000);
          }

          if(this.item.weight > 20000) {
            this.item.estimatedPickupPrice = 0;
          } else {
            this.item.estimatedPickupPrice = 2000;
          }

          let cw = parseInt(this.item.weight);

          this.item.estimatedPrice = this.$data.expressBasicPrice.val2;

          cw -= this.$data.expressBasicPrice.val;

          while(cw > 0) {
            this.item.estimatedPrice += this.$data.expressAddPrice.val2;
            cw -= this.$data.expressAddPrice.val;
          }
          // if(this.item.weight > 100) {
          //   this.item.estimatedPrice = this.item.basePrice;
          // }
          //
          // for(let i = 100 ; i < this.item.weight ;) {
          //   this.item.estimatedPrice += this.item.addPrice;
          //   i += 50; //increase half kg
          // }
          //this.item.estimatedPrice = 0;
          this.item.estimatedTotalPrice = this.item.estimatedPickupPrice + this.item.estimatedPrice;
          console.log(this.item);
        },
        addItem: function() {
          let newSubItem = getNewSubItem();
          this.itemList.push(newSubItem);
        },
        removeBox: function(index) {
          this.item.boxList.splice(index, 1);
        },
        addBox: function() {
          let newBox = {
            x:0,
            y:0,
            z:0,
            aw:0,
            vw:0,
            cw:0,
          }
          this.item.boxList.push(newBox);
        },
        onSubItemValueChanged: function(index) {
          let totalValue = 0;
          if(this.itemList.length > 0) {
            for(let i = 0 ; i < this.itemList.length ; i++) {
              totalValue += this.itemList[i].value*this.itemList[i].amount;
            }
          }

          this.item.value = parseInt(totalValue*100);
        }
      }
    }
</script>

<style scoped>
  label.form-control {
    border: none;
    text-align: right;
  }
  .col-12 {
    padding-top:5px;
    padding-bottom: 5px;
  }
  .fullscreen-container {
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    left: 0;
    background-color: white;
    display: none;
  }
  .center-container {
    width: 90%;
    height: 90%;
    display:none;
    position:relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow:hidden;
    -webkit-overflow-scrolling:touch;
  }
  .no-padding {
    padding:0;
  }
  .no-padding > .form-control {
    padding-left: 0;
    padding-right: 0;
    /*text-align: center;*/
    text-align-last:center;
  }
</style>



// WEBPACK FOOTER //
// src/form/ExpressForm.vue